import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, Checkbox, Popover, } from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import * as Suggestion from '@services/suggestion/suggestion.action';
import LocationIcon from '@material-ui/icons/PlaceRounded';
import TimeIcon from '@material-ui/icons/ScheduleRounded';
import SendIcon from '@material-ui/icons/Send';
import { EditEventStyle } from './EditEvent.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IScheduleEvent } from '@components/calendar2/dayDetails/scheuldeEvent.types';
import VVTimePicker from '@components/common/timepicker/VVTimePicker';
import VVDatePicker from '@components/common/timepicker/VVDatePicker';
import { ICreateSuggestion } from '@app-types/websocket/suggestion.types';
import {
  applyChanges,
  applyDayvisitChanges,
  applyDayvisitChangesToAllEntries,
  applyToAllEntries,
} from '../editPane/editActions/QuickChange/QuickChangeCalc';
import { generateSuggestions } from '@helpers/calendar/suggestionCalculator';
import { schoolAgeFromFamily } from '@helpers/schoolHelper';
import { ISchedule } from '@app-types/websocket/schedule.types';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  start: {
    dateTemp:Date;
    locationTemp:string;
    atSchoolTemp:boolean;
    edit:"TIME"|"DATE"|null;
    editAnchorEl:HTMLDivElement|null;}|undefined
  end: {
    dateTemp:Date;
    locationTemp:string;
    atSchoolTemp:boolean;
    edit:"TIME"|"DATE"|null;
    editAnchorEl:HTMLDivElement|null;}|undefined
}

interface IProps extends WithStyles<typeof EditEventStyle> {
  userId:number,
  family:IFamilyMember[];
  close:() => void;
  event: IScheduleEvent;
  createSuggestion: (data: ICreateSuggestion) => void;
  position: "START"|"END"|"DAYVISIT";
  saveToOngoingSchedule?: (newSchedule: ISchedule) => void;
}

class EditScheduleEvent extends React.Component<IProps, IState> {

  private dateRefStart:React.RefObject<HTMLDivElement> = React.createRef();
  private timeRefStart:React.RefObject<HTMLDivElement> = React.createRef();
  private placeRefStart:React.RefObject<HTMLInputElement> = React.createRef();

  private dateRefEnd:React.RefObject<HTMLDivElement> = React.createRef();
  private timeRefEnd:React.RefObject<HTMLDivElement> = React.createRef();
  private placeRefEnd:React.RefObject<HTMLInputElement> = React.createRef();

  constructor(props: IProps) {
    super(props);
    this.state = (this.resetState(props));
  }

  public resetState(props: IProps):IState {
    let first:{
      dateTemp:Date;
      locationTemp:string;
      atSchoolTemp:boolean;
      edit:"TIME"|"DATE"|null;
      editAnchorEl:HTMLDivElement|null;}|undefined;
    let second:{
      dateTemp:Date;
      locationTemp:string;
      atSchoolTemp:boolean;
      edit:"TIME"|"DATE"|null;
      editAnchorEl:HTMLDivElement|null;}|undefined;

    if (props.position === "START" || props.position === "DAYVISIT"){ 
      let date:Date;
      let loc:string;
      let atSchool:boolean = false;
      date = new Date(props.event.startTime);
      loc = props.event.startLoc?props.event.startLoc:"";
      atSchool = props.event.startAtSchool;
      first = {dateTemp:date, locationTemp:loc, atSchoolTemp:atSchool, edit:null, editAnchorEl:null};
    }
    if (props.position === "END" || props.position === "DAYVISIT"){
      let date:Date;
      let loc:string;
      let atSchool:boolean = false;
      date = new Date(props.event.endTime);
      loc = props.event.endLoc?props.event.endLoc:"";
      atSchool = props.event.endAtSchool;
      second = {dateTemp:date, locationTemp:loc, atSchoolTemp:atSchool, edit:null, editAnchorEl:null};
    }

    return {
      start:first,
      end:second
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    if (prevProps.event !== this.props.event || prevProps.position !== this.props.position) {
      this.setState(this.resetState(this.props));
    }
  } 

  public render() {
    const {classes, family, userId, event, position} = this.props;

    let from:string =tn.lang.unknown;
    let to:string =tn.lang.unknown;
    const otherParentId:number = event.schedule.data.parentA === event.parent?event.schedule.data.parentB:event.schedule.data.parentA

    let originalDate:Date;

    const saveButton:JSX.Element = (<Button variant="contained"  onClick={() => this.save()} disabled={!this.validToSave()} color="primary" 
            classes={{contained:classes.buttonContainedLarge}} 
            fullWidth={this.props.saveToOngoingSchedule === undefined?false:true}
            endIcon={this.props.saveToOngoingSchedule === undefined?<SendIcon style={{fontSize: '20px', margin: '-2px 0px'}}/>:undefined}>
            {this.props.saveToOngoingSchedule === undefined?tn.lang.suggestCange:tn.lang.save}
          </Button>);

    const saveAllButton:JSX.Element = (<Button variant="outlined"  onClick={() => this.saveAll()} disabled={!this.validToSave()} 
          style={this.props.saveToOngoingSchedule === undefined
            ?{display:'none'}
            :{}}
          classes={{outlined:classes.buttonOutlinedLarge}} >
          {tn.lang.calEventAll}
        </Button>);

    if (position === "DAYVISIT") {
      originalDate = new Date(this.props.event.startTime);
      from = tn.familyMemberName(event.parent, family);
      to = tn.familyMemberName(event.parent, family);
    } else if (position === 'END') {
      originalDate = new Date(this.props.event.endTime);
      from = tn.familyMemberName(event.parent, family);
      to =  tn.familyMemberName(otherParentId, family);
    } else {
      originalDate = new Date(this.props.event.startTime);
      to = tn.familyMemberName(event.parent, family);
      from =  tn.familyMemberName(otherParentId, family);
    }
    const kids:string = tn.familyMemberNames(event.children,family);

    return (
    <div  className={classes.scrollView} >
      <div className={classes.pane}>
        <div className={classes.section} style={{borderBottom: '1px solid #888'}}>
          <div style={{flexDirection: 'column', display:'flex', alignItems: 'center'}}>
            {this.props.position === "DAYVISIT"
              ?<>
                <span>{tn.lang.calQuickChangeDayvisitFor(kids)}</span>
                <span style={{fontSize: '20px', padding: '6px', fontWeight: 600}}>{tn.lang.calDayvistAt(to)} </span>
                <span>{tn.formatDateDayMonthYear(originalDate)}</span>
              </>
              :<>
                <span>{tn.lang.calQuickChangeFor(kids)}</span>
                <span style={{fontSize: '20px', padding: '6px', fontWeight: 600}}>{tn.lang.calHandoverToFrom(from,to)} </span>
                <span>{tn.formatDateDayMonthYear(originalDate)}</span>
              </>
            }
          </div>
        </div>

        {(position === "START" || position === "DAYVISIT")?this.renderHandover("start"):undefined}
        {(position === "END" || position === "DAYVISIT")?this.renderHandover("end"):undefined}
        
      </div>
      <div className={classes.actions} style={{flexDirection: 'column' , position: 'relative'}}>
        <div style={{display: 'flex', gap: '12px', width:'100%', alignItems: 'center'}}>
          <Button variant="outlined"  classes={{outlined:classes.buttonOutlinedLarge}} onClick={() => this.props.close()}>{tn.lang.cancel}</Button>
          {this.props.saveToOngoingSchedule === undefined?saveButton:saveAllButton}
        </div>
        {this.props.saveToOngoingSchedule === undefined?saveAllButton:saveButton}
      </div>
    </div>);
  }

  private renderHandover(position:"start"|"end"):JSX.Element {

    if (position === "start" && this.state.start === undefined) return <div/>;
    if (position === "end" && this.state.end === undefined) return <div/>;

    const {classes} = this.props;
    const handover = position==="start"?this.state.start!:this.state.end!
    const {atSchoolTemp, locationTemp, dateTemp, edit, editAnchorEl} = handover;
    const school = this.props.event.schedule.school;
    const schoolAge = schoolAgeFromFamily(this.props.family);


    return (
      <div className={classes.section} >
        <div className={classes.row}>
          <div className={classes.leftColumn} ><TimeIcon className={classes.greyIcon}/></div>
          <div className={classes.rightColumn} >
          <div className={classes.fullwidth} />
          <div style={{display: 'flex', width: '233px'}}>
            <div className={classes.greyInput + " " +classes.date} ref={position==="start"?this.dateRefStart:this.dateRefEnd}
              onClick={() => {
                if (position==="start") this.setState({start:{...handover, edit:"DATE", editAnchorEl:this.dateRefStart.current}})
                else this.setState({end:{...handover, edit:"DATE", editAnchorEl:this.dateRefEnd.current}})
                }}>
              {tn.formatDateDayMonthYear(dateTemp)}
            </div>
            <div className={classes.greyInput + " " +classes.time} ref={position==="start"?this.timeRefStart:this.timeRefEnd}
              style={atSchoolTemp?{maxWidth: 0, minWidth:0, padding: 0,margin: 0}:{}}
              onClick={() => {
                  if (position==="start") this.setState({start:{...handover, edit:"TIME", editAnchorEl:this.timeRefStart.current}})
                  else this.setState({end:{...handover, edit:"TIME", editAnchorEl:this.timeRefEnd.current}})
                }}>
              <span>{tn.formatTime(dateTemp)}</span>
            </div>
          </div>
          </div>
        </div>

        <div className={classes.row} style={{maxHeight:'unset'}} >
          <div className={classes.leftColumn} >
            <LocationIcon className={classes.greyIcon}/>
          </div>
          <div className={classes.fullwidth} />
          <div className={classes.rightColumn} style={{flexDirection: 'column', minWidth:'234px'}}>
            <div style={{display:'flex', flexDirection:'column', transition: '0.3s', overflow: 'hidden',
              maxHeight: (atSchoolTemp?'0px':'48px'),}} >
              <input
                ref={position==="start"?this.placeRefStart:this.placeRefEnd}
                id="event-location"
                type="text"
                value={atSchoolTemp?tn.lang.schedulePickupSchool(school, schoolAge):locationTemp}
                spellCheck={true}
                maxLength={25}
                onChange={(e) => {
                  if (position === "start") this.setState({start:{...handover, locationTemp:e.target.value}})
                  else this.setState({end:{...handover, locationTemp:e.target.value}})
                }}
                className={classes.greyInput + " " +classes.fullwidthInput}
                placeholder={tn.lang.handoverLocationLabel}/>

              <div className={classes.error} style={(locationTemp.length === 0 && !atSchoolTemp)?{maxHeight:'16px'}:{}}>
                {tn.lang.calPlaceMissing}
              </div>
            </div>

            <div onClick={() => {
              const schoolTime = new Date(dateTemp); schoolTime.setHours(12); schoolTime.setMinutes(0);
              const newTime = new Date(dateTemp); newTime.setHours(position==="start"?9:18); newTime.setMinutes(0);
              if (position === "start") {
                this.setState({start:{...handover, atSchoolTemp:!atSchoolTemp, dateTemp:((!atSchoolTemp)?schoolTime:newTime), }})}
              else {this.setState({end:{...handover, atSchoolTemp:!atSchoolTemp, dateTemp:((!atSchoolTemp)?schoolTime:newTime),}})}
              }} style={{display: 'flex', alignItems: 'center'}}>
              <Checkbox
                edge="start"
                checked={atSchoolTemp}
                tabIndex={-1}
                readOnly={true}
                disableRipple={true}
                style={{marginLeft: '-10px'}}
              />
              <span>
                {tn.lang.schedulePickupSchool(school, schoolAge)}
              </span>
            </div>
          </div>
        </div>
        <Popover 
          anchorEl={editAnchorEl}
          disableScrollLock={true}
          onClose={() => {
            if (position === "start") this.setState({start:{...handover,edit:null}}); 
            else this.setState({end:{...handover,edit:null}});}}
          open={(edit === "TIME")}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <VVTimePicker 
            open={(edit === "TIME")}
            hour={dateTemp.getHours()}
            minute={dateTemp.getMinutes()}
            setHour={(hour:number) => {const newTime = new Date(dateTemp); newTime.setHours(hour); 
              if (position === "start") this.setState({start:{...handover,dateTemp:newTime}}); 
              else this.setState({end:{...handover,dateTemp:newTime}}); }}
            setMinute={(min:number) => {const newTime = new Date(dateTemp); newTime.setMinutes(min); 
              if (position === "start") this.setState({start:{...handover,dateTemp:newTime}}); 
              else this.setState({end:{...handover,dateTemp:newTime}});}}
          />
        </Popover>
        <Popover 
          anchorEl={editAnchorEl}
          disableScrollLock={true}
          onClose={() => {if (position === "start") this.setState({start:{...handover,edit:null}}); 
            else this.setState({end:{...handover,edit:null}});}}
          open={(edit === "DATE")}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <VVDatePicker 
            open={(edit === "DATE")}
            date={dateTemp}
            setDate={(date:Date) => {const newTime = new Date(date); 
              newTime.setMinutes(dateTemp.getMinutes()); 
              newTime.setHours(dateTemp.getHours()); 
              if (position === "start") this.setState({start:{...handover,dateTemp:newTime}});
              else this.setState({end:{...handover,dateTemp:newTime}});}}
          />
        </Popover>
      </div>
    );
  }

  private validToSave():boolean {    
    if (this.props.position === "START" ) {
      if (this.state.start === undefined) return false;
      if (this.state.start.dateTemp.getTime() === this.props.event.startTime
        && this.state.start.locationTemp === (this.props.event.startLoc?this.props.event.startLoc:"")
        && this.state.start.atSchoolTemp === this.props.event.startAtSchool ) {
        return false;
      } else {
        return true;
      }
    } else if (this.props.position === "END" ) {
      if (this.state.end === undefined) return false;
      if (this.state.end.dateTemp.getTime() === this.props.event.endTime
        && this.state.end.locationTemp === (this.props.event.endLoc?this.props.event.endLoc:"")
        && this.state.end.atSchoolTemp === this.props.event.endAtSchool ) {
        return false;
      } else {
        return true;
      }
    } else if (this.props.position === "DAYVISIT" ) {
      if (this.state.start === undefined) return false;
      if (this.state.end === undefined) return false;
      if (this.state.start.dateTemp.getTime() >= this.state.end.dateTemp.getTime()) return false;
      if (this.state.end.dateTemp.getTime() === this.props.event.endTime
        && this.state.end.locationTemp === (this.props.event.endLoc?this.props.event.endLoc:"")
        && this.state.end.atSchoolTemp === this.props.event.endAtSchool 
        && this.state.start.dateTemp.getTime() === this.props.event.startTime
        && this.state.start.locationTemp === (this.props.event.startLoc?this.props.event.startLoc:"")
        && this.state.start.atSchoolTemp === this.props.event.startAtSchool ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  private saveAll():void {
    const original = this.props.event;
    let newSchedule = original.schedule;
    if (this.props.position === "DAYVISIT" && this.startChanged() && this.endChanged()) {
      newSchedule = applyDayvisitChangesToAllEntries(newSchedule, original.parent, new Date(original.startTime), new Date(original.endTime),
        {time:this.state.start!.dateTemp.getTime(), loc:this.state.start!.locationTemp, atSchool:this.state.start!.atSchoolTemp},
        {time:this.state.end!.dateTemp.getTime(), loc:this.state.end!.locationTemp, atSchool:this.state.end!.atSchoolTemp});
    } else if ((this.props.position === "START" || this.props.position === "DAYVISIT") && this.startChanged()) {
      newSchedule =  applyToAllEntries(newSchedule, original.parent, new Date(original.startTime),
        "START", this.state.start!.dateTemp.getTime(), this.state.start!.locationTemp, this.state.start!.atSchoolTemp);

    } 
    if (!(this.props.position === "DAYVISIT" && this.startChanged() && this.endChanged())
      && (this.props.position === "END" || this.props.position === "DAYVISIT") && this.endChanged()) {
      newSchedule =  applyToAllEntries(newSchedule, original.parent, new Date(original.endTime),
        "END", this.state.end!.dateTemp.getTime(), this.state.end!.locationTemp, this.state.end!.atSchoolTemp);
    }
    if (this.props.saveToOngoingSchedule !== undefined) {
      this.props.saveToOngoingSchedule(newSchedule);
    } 
    this.props.close();
  }

  private save():void {
    const original = this.props.event;
    let newSchedule = original.schedule;
    if (this.props.position === "DAYVISIT" && this.startChanged() && this.endChanged()) {
      newSchedule = applyDayvisitChanges(newSchedule, original.parent, original.eventId,
        {time:this.state.start!.dateTemp.getTime(), loc:this.state.start!.locationTemp, atSchool:this.state.start!.atSchoolTemp},
        {time:this.state.end!.dateTemp.getTime(), loc:this.state.end!.locationTemp, atSchool:this.state.end!.atSchoolTemp});
    } else if ((this.props.position === "START" || this.props.position === "DAYVISIT") && this.startChanged()) {
      newSchedule =  applyChanges(newSchedule, original.parent, original.eventId,
        "START", this.state.start!.dateTemp.getTime(), this.state.start!.locationTemp, this.state.start!.atSchoolTemp);
    }
    if (!(this.props.position === "DAYVISIT" && this.startChanged() && this.endChanged())
      && (this.props.position === "END" || this.props.position === "DAYVISIT") && this.endChanged()) {
      newSchedule =  applyChanges(newSchedule, original.parent, original.eventId,
        "END", this.state.end!.dateTemp.getTime(), this.state.end!.locationTemp, this.state.end!.atSchoolTemp);
    }
    if (this.props.saveToOngoingSchedule !== undefined) {
      this.props.saveToOngoingSchedule(newSchedule);
    } else {
      const suggestion:ICreateSuggestion = generateSuggestions(original.schedule, newSchedule);
      if (suggestion.changes.length > 0) {
        suggestion.track=true;
        this.props.createSuggestion(suggestion);
      }
  
    }
    // console.log("RESULT: "+JSON.stringify(suggestion));
    this.props.close();
  }

  private startChanged():boolean {
    if (this.state.start === undefined) return false;
    return this.state.start.dateTemp.getTime() !== this.props.event.startTime
      || this.state.start.locationTemp !== (this.props.event.startLoc?this.props.event.startLoc:"")
      || this.state.start.atSchoolTemp !== this.props.event.startAtSchool;
  }

  private endChanged():boolean {
    if (this.state.end === undefined) return false;
    return this.state.end.dateTemp.getTime() !== this.props.event.endTime
      || this.state.end.locationTemp !== (this.props.event.endLoc?this.props.event.endLoc:"")
      || this.state.end.atSchoolTemp !== this.props.event.endAtSchool;
  }

}


function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family:state.family.family,
  };
}

const mapDispatchToProps = {
  createSuggestion: Suggestion.createSuggestion,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EditEventStyle)(EditScheduleEvent));



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/EditScheduleEvent.tsx